import useUserData from "../../../hooks/user/useUserData";
import {useTranslation} from "react-i18next";
import {ALERTS} from "../../../locales/components/namespaces";
import {useEffect, useState} from "react";
import {API} from "../../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors, logoutUnauthorizedUser} from "../../../helpers/errorHandling";
import axios from "axios";
import useUserAction from "../../../hooks/user/useUserAction";
import { showPopup } from '../../../../src/components/globalPopup/globalPopupService';
import { useLocation } from "react-router";
import { useRepaymentsContext } from "./RepaymentsContext";

const useRepayments = ({id}) => {
	const {token, isLoggedIn} = useUserData()
	const {userLogout} = useUserAction()
	const {t} = useTranslation(ALERTS)
	const [loading, setLoading] = useState(false)
	const [repayments, setRepayments] = useState([])
	const [updateRepayments, setUpdateRepayments] = useState(false)
	const location = useLocation()

	const queryParams  =      new URLSearchParams(window.location.search);
	const repaymentsParams = queryParams.get("repayments");
	const decodedrepayments = decodeURIComponent(repaymentsParams);
	const repaymentsArray = JSON.parse(decodedrepayments);
	const { repaymentsContext, clearRepayments } = useRepaymentsContext();




	
	const handleUpdateRepayments = (updateRepayments) => setUpdateRepayments(updateRepayments)
	


	useEffect(() => {
		if (Array.isArray(repaymentsArray)) {
			console.log('repaymentsArray useRepayments');
			console.log(repaymentsArray);
			console.log('repaymentsArray useRepayments');

			setRepayments(repaymentsArray);
		}
	}, []);




	useEffect(() => {
		if (location.pathname === '/fast/calculation' && repaymentsContext.length > 0) {
			const mergedRepayments = [...repayments];
			repaymentsContext.forEach((newItem) => {
				const existingIndex = mergedRepayments.findIndex(item => item.id === newItem.id);
				if (existingIndex !== -1) {
					mergedRepayments[existingIndex] = newItem;
				} else {
					mergedRepayments.push(newItem);
				}
			});
			setRepayments(mergedRepayments);
		}
	}, [repaymentsContext]);

	useEffect(() => {
		if (location.pathname === '/fast/calculation' || location.pathname === '/calculations/create'){
			return
		}



		setLoading(true)
		axios({
			method: 'post',
			data: {CalculationId: id},
			headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
			url: `${API}/repayment/details/data`,
		}).then(response => {
			const repaymentsData = response.data

			setRepayments(repaymentsData)			
			if( Array.isArray(repaymentsArray) && repaymentsData?.length === 0 ) {
				setRepayments(repaymentsArray);
			}
			setLoading(false)
		}).catch(error => {
			setLoading(false)
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to get details.')), {
					variant: 'error'
				}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})



	}, [updateRepayments])
	const handleRemoveRepayment = (id, callback = null) => {

		if (location.pathname === '/fast/calculation') {
			const combined = [...repayments];
			const filtered = combined.filter(item => item.id !== id);
			setRepayments(filtered);
			setUpdateRepayments(!updateRepayments)
			if (callback) callback(id)
			return;
		}


		axios({
			method: 'post',
			headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
			url: `${API}/repayment/remove`,
			data: {
				RepaymentId: id
			}
		}).then(() => {
			// enqueueSnackbar(t('Repayment deleted successfully!'), {
			// 		variant: 'success'
			// 	}
			// )
            showPopup({
				title: '',
				message:  t('Repayment deleted successfully!'),
				onConfirm: () => {
			
				}
			});


			setUpdateRepayments(!updateRepayments)
			if (callback) callback(id)
		}).catch(error => {
			setUpdateRepayments(!updateRepayments)
			enqueueSnackbar(handleAxiosErrors(error, t('Failed to delete repayment!')), {
					variant: 'error'
				}
			)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}


	return {
		loading,
		repayments,
		updateRepayments,
		handleUpdateRepayments,
		handleRemoveRepayment,
	}
}
export default useRepayments

//TODO::Use Logic if Edit
// useEffect(() => {
//     setLoading(false)
//     if (id) {
//         axios({
//             method: 'post',
//             data: {RepaymentId: id},
//             headers: {'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`},
//             url: `${API}/repayment/edit/data`,
//         }).then(response => {
//             let data = response.data
//             if (data.repayments && data.repayments.length > 0) {
//                 const repayments = data.repayments[0]
//                 setRepayments({
//                     LoanAmount: Number(repayments.RequestedAmount),
//                     FixedInterestRate: Number(repayments.FixedRate),
//                     FloatingRate: Number(repayments.FloatRate),
//                     ContributionId: repayments.ContributionId,
//                     DateInstallment: moment(repayments.StartDt),
//                 })
//             }
//             setLoading(false)
//         }).catch(error => {
//             setLoading(false)
//             enqueueSnackbar(handleAxiosErrors(error, t('Failed to get repayment details.')), {
//                     variant: 'error'
//                 }
//             )
//              logoutUnauthorizedUser(error, isLoggedIn, userLogout)
//         })
//     }
// }, [id])